import type React from "react";
import { useEffect, useMemo, useReducer, useState } from "react";
import CalculatorForm from "../CalculatorForm/CalculatorForm";
import { PageContainerComponent, PageContent } from "./PageContainer.styles";
import "../CalculatorForm/CalculatorForm.css";
import type { AxiosError } from "axios";
import { getNetCarbonIntensity } from "../../api/services";
import { fivehundres } from "../../constants";
import { useNetCarbonIntensity } from "../../context/NetCarbonIntensityContext";
import { AppContext } from "../../context/calculatorFormContext";
import { calculatorFormReducer } from "../../reducers/ActionHandlers/CalculatorActionHandler";
import { calculateFormInitialState } from "../../reducers/InitialStates/CalculatorInitialState";
import type { IAuthToken } from "../../types/types";
import { showToast } from "../AllDeals/utils";
import Footer from "../Footer/Footer";
import Loader from "../Loader";

interface PageContainerProps {
  user: IAuthToken;
}

const PageContainer: React.FC<PageContainerProps> = ({ user }) => {
  const [state, dispatch] = useReducer(calculatorFormReducer, calculateFormInitialState);
  const { dispatch: myDispatch } = useNetCarbonIntensity();
  const [isLoadingNCI, setIsLoadingNCI] = useState(true);

  const getNetCarbonIntensityData = async () => {
    setIsLoadingNCI(true);
    try {
      const netcarbonintensityRes = await getNetCarbonIntensity();
      myDispatch({ type: "setNetCarbonIntensity", payload: netcarbonintensityRes.data });
    } catch (err) {
      const error = err as AxiosError<Error>;
      console.error("❌ Error fetching NetCarbonIntensity data:", error);
      showToast(error?.response?.status ?? fivehundres, "Error while fetching deal details.");
    } finally {
      setIsLoadingNCI(false);
    }
  };

  useEffect(() => {
    getNetCarbonIntensityData();
  }, []);
  const value = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);
  return (
    <>
      <Loader isLoading={isLoadingNCI} message={"Loading Carbon Intensity Data"} />
      <PageContainerComponent>
        <PageContent>
          <AppContext.Provider value={value}>
            <CalculatorForm userName={user.email} authUser={user} />
          </AppContext.Provider>
        </PageContent>
      </PageContainerComponent>
      <Footer />
    </>
  );
};

export default PageContainer;
